<template>
  <div class="container mt-64 flex justify-between items-center mx-auto px-8 md:px-14 lg:px-24 w-full">
        <section class="w-full">
            <h2 id="hire" class="secondary-title">Contact me</h2>
            <p class="section-paragraph">Feel free to to contact me any time, through any method below.</p>
            <div class="w-full grid lg:grid-cols-2 gap-8 lg:gap-32 mt-24">
                <form action="https://formsubmit.co/fabriciobencomo.viloria@gmail.com" method="POST">
                    <div class="space-y-12">
                        <div>
                            <label class="block mb-6 text-xl font-bold">Name</label>
                            <input class="w-full border border-input-border bg-input rounded-sm  px-4 py-4 text-white" name="name">
                        </div>
                        <div>
                            <label class="block mb-6 text-xl font-bold">Email</label>
                            <input type="email" class="w-full border border-input-border rounded-sm  bg-input px-4 py-4 text-white" name="email">
                        </div>
                        <div>
                            <label class="block mb-6 text-xl font-bold">Message</label>
                            <textarea type="email" class="w-full border border-input-border rounded-sm  bg-input px-4 py-4 text-white h-56 resize-none" name="message"></textarea>
                        </div>
                        <button class="px-6 py-2 bg-theme text-white font-bold rounded-sm ">Send it!</button>
                    </div>
                </form>
                <div class="mt-12">
                    <!-- Contact info -->
                    <p class="text-secondary">+58 414-4244614</p>
                    <a href="mailto:fabriciobencomo.viloria@gmail.com" class="text-secondary underline mt-3 block">fabriciobencomo.viloria@gmail.com</a>

                    <!-- Socials -->
                    <div class="flex mt-20 space-x-6">
                        <!-- Linkedin -->
                        <a href="https://www.linkedin.com/in/fabricio-bencomo-644829181/" target="_blank">
                            <svg class="w-8 h-8 lg:w-12 lg:h-12"  xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" fill="#3F3FFF"/></svg>
                        </a>
                        <!-- Github -->
                        <a href="https://github.com/fabriciobencomo" target="_blank">
                            <svg class="w-8 h-8 lg:w-12 lg:h-12" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" fill="#3F3FFF"/></svg>								
                        </a>
                    </div>
                </div>
                
            </div>

        </section>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>